import { Locale } from 'vant';
import en from 'vant/lib/locale/lang/en-US';
import cn from 'vant/lib/locale/lang/zh-CN';
import tw from 'vant/lib/locale/lang/zh-TW';
import ja from 'vant/lib/locale/lang/ja-JP';
import ko from './vant-ko';

const messages = { en_US: en, zh_CN: cn, zh_TW: tw, ja_JP: ja, ko_KR: ko };
export function applyUiLocale(locale) {
  const language = messages[locale] ? locale : 'zh_TW';
  Locale.use(language.replace('_', '-'), messages[language]);
  if (typeof document !== 'undefined') document.documentElement.lang = language.replace('_', '-');
}
